$('.faq-question').click(function () {
    $(this).toggleClass('open');
    $(this).next('.faq-answer').slideToggle(200);
  });